import { gql, useQuery } from "@apollo/client";

export const Items = gql`
	query Items($term: String) {
		items(term: $term) {
			_id
			name
			ref
			count
			brand
		}
	}
`;

export const GET_ITEMS = gql`
	query GetItems($term: String) {
		items(term: $term) {
			_id
			name
			ref
			count
			brand
		}
	}
`;

export const GET_ITEM = gql`
	query GetItem($id: String!) {
		item(id: $id) {
			_id
			name
			ref
			count
			brand
		}
	}
`;
export const GET_ITEM_BY_REF = gql`
	query itemByRef($ref: String!) {
		itemByRef(ref: $ref) {
			_id
			name
			ref
			count
			brand
		}
	}
`;
